import http from 'hub-http/clients/apiClient';
//@ts-expect-error missing types
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
//@ts-expect-error missing types
import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
import { createGetCosIndexConnectionsParents } from '../api/CosIndexConnectionsParentsAPI';
export const createCosIndexConnectionsParentsReferenceResolver = args => createBatchedReferenceResolver({
  cacheKey: CacheKeys.COS_INDEX_CONNECTIONS_PARENTS,
  httpClient: args.httpClient,
  createFetchByIds: ({
    httpClient
  }) => {
    return createGetCosIndexConnectionsParents(httpClient, args.portalId)(args.query);
  },
  fetchByIds: createGetCosIndexConnectionsParents(http)(args.query)
});
export default createCosIndexConnectionsParentsReferenceResolver({
  query: {
    parentType: 'CONTENT',
    levels: 0,
    fields: 'BASIC'
  }
});